import { LoginErrors, LoginLabels } from '@dxp-module/login'

export const labels: LoginLabels = {
  title: 'trans__myaccount__create_an_account__login__title',
  subTitle: 'trans__myaccount__create_an_account__login__sub_title',
  emailAddressLabel:
    'trans__myaccount__create_an_account__login__email_address_label',
  passwordLabel: 'trans__myaccount__create_an_account__login__password_label',
  forgotPasswordLabel:
    'trans__myaccount__create_an_account__login__forgot_password_label',
  loginCTAButtonLabel: 'trans__myaccount__create_an_account__login__cta_label',
  requiredFieldsLabel: 'trans__myaccount__login__mandatory_label',
}
export const errors: LoginErrors = {
  emptyEmail: 'trans__myaccount__errors__empty_email_address',
  invalidEmailFormat: 'trans__myaccount__errors__invalid_email_address_format',
  invalidEmailLength: 'trans__myaccount__errors__invalid_email_address_length',
  invalidPassword: 'trans__myaccount__errors__incorrect_password',
}
